import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { easeStripe } from '../../lib/motion';

export function PageTransition({ children }: { children: ReactNode }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <div>{children}</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: easeStripe }}
    >
      {children}
    </motion.div>
  );
}
